<a class="btn btn-gray-fill" [routerLink]="route">
    <svg-icon src="assets/svg/dashboard.svg"></svg-icon>
    {{'dashboards.button'|translate}}
</a>
